var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H42V30C42 36.6274 36.6274 42 30 42H21V21Z",
    fill: "#ECF2F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H30C36.6274 0 42 5.37258 42 12V21H21V0Z",
    fill: "#EB53FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H21V42H12C5.37258 42 0 36.6274 0 30V12Z",
    fill: "#4870FF"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDIxSDQyVjMwQzQyIDM2LjYyNzQgMzYuNjI3NCA0MiAzMCA0MkgyMVYyMVoiIGZpbGw9IiNFQ0YyRjUiLz4KPHBhdGggZD0iTTIxIDBIMzBDMzYuNjI3NCAwIDQyIDUuMzcyNTggNDIgMTJWMjFIMjFWMFoiIGZpbGw9IiNFQjUzRkYiLz4KPHBhdGggZD0iTTAgMTJDMCA1LjM3MjU4IDUuMzcyNTggMCAxMiAwSDIxVjQySDEyQzUuMzcyNTggNDIgMCAzNi42Mjc0IDAgMzBWMTJaIiBmaWxsPSIjNDg3MEZGIi8+Cjwvc3ZnPgo=";
export { SvgColors as ReactComponent };